module.exports = __webpack_public_path__ + "static/counselling2-fbfba3b2758abae163cb3a815b2906ab.png";